import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

import { TransferCouponCodeService } from '../../../services/index';
import { AddEditTransferCouponCodeComponent } from './addEditTransferCouponCode.component';

@Component({
    selector: 'transfer-coupon-code-tab',
    templateUrl: './transferCouponCode.component.html'
})
export class TransferCouponCodeComponent implements OnInit {

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() params: any[] = [];

    isLoadMask: Promise<any>;
    transferPointsData: any[];
    loadingIndicator: boolean = true;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'transfer_date',
        orderDir: 'desc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    columns = [];
    toggleCol = [];
    filterData = {
        "search_data": ""
    };
    scrollTimeout: any;
    suppressPaging: boolean = false;
    filterExpand: boolean = true;
    bsModalRef: BsModalRef;

    constructor(
        private transferCouponCodeService: TransferCouponCodeService,
        private modalService: BsModalService
    ) { }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellClass: 'cell-center', cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Transfer Date', prop: 'transfer_date', width: 150, minWidth: 150, maxWidth: 180, toggle: true },
            { name: 'From Client ID', prop: 'from_client_no', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'From Client Name', prop: 'from_client_name', sortable: false, width: 180, minWidth: 180, maxWidth: 180 },
            { name: 'Coupon Code', prop: 'coupon_code', width: 150, minWidth: 150, maxWidth: 180 },
            { name: 'To Client ID', prop: 'to_client_no', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'To Client Name', prop: 'to_client_name', sortable: false, width: 180, minWidth: 180, maxWidth: 180 },
            { name: 'Remarks', prop: 'remarks', sortable: false, width: 200, minWidth: 200, maxWidth: 280, cellClass: 'cell-left' }
        ];

        this.toggleCol = Object.assign({}, this.columns);
        this.pageCallback({ offset: 0 });
    }

    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getTransferCouponCodeList();
    }

    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.getTransferCouponCodeList();
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            // clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100);
    }

    clearFilter(): void {
        this.filterData = {
            "search_data": ""
        };
        this.applyFilter();
    }

    applyFilter(): void {
        this.pageCallback({ offset: 0 });
    }

    getTransferCouponCodeList() {
        this.loadingIndicator = true;

        let query = {
            start: this.page.offset * this.page.limit,
            limit: this.page.limit,
            search_data: this.filterData.search_data
        };

        this.isLoadMask = this.transferCouponCodeService.getTransferCouponCodeList(query).then((data: any) => {
            this.transferPointsData = data.data;
            this.page.count = data.totCnt;
            this.loadingIndicator = false;
        }).catch((err: any) => {
            console.log(err);
            this.loadingIndicator = false;
        });
    }

    addEditTransferCouponCode(mode: string = 'Add', rowData?: any) {
        const initialState = {
            title: mode === 'Add' ? 'Transfer Coupon Code' : 'View Transfer',
            mode: mode,
            data: rowData || {}
        };

        this.bsModalRef = this.modalService.show(AddEditTransferCouponCodeComponent, {
            initialState,
            class: 'modal-lg',
            backdrop: 'static'
        });

        this.bsModalRef.content.onClose.subscribe((result: any) => {
            if (result) {
                this.getTransferCouponCodeList();
            }
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/transferCouponCode/transferCouponCode.component.ts